import { Component, input, output } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-radio-card',
  styleUrl: './radio-card.scss',
  templateUrl: './radio-card.html',
})
export class RadioCard {
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly value = input.required<string>();
  readonly name = input<string>('radio-card-group');
  readonly checked = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  /** Selo exibido no card desabilitado; vazio, o card fica desabilitado sem selo. */
  readonly badge = input<string>('Não disponível');

  readonly selected = output<string>();

  protected handleChange(): void {
    this.selected.emit(this.value());
  }
}
